<template>
  <div v-if="props.sides" class="border rounded-1 p-1 bg-light d-inline-block mt-1 mb-3">
    <div class="fw-bold text-muted mb-2 small">Zvolte strany:</div>
    <div class="d-flex col-auto gap-4">
      <div v-for="(value, side) in props.sides" :key="side" class="form-check mb-0">
        <input 
          type="checkbox" 
          class="form-check-input" 
          :id="`side-selector-${side}`"
          :checked="selectedSides.hasOwnProperty(side)"
          @change="toggleSelectSides({[side]: value}, $event.target.checked)"
        >
        <label class="form-check-label small" :for="`side-selector-${side}`">
          {{ side }} : {{ value }}
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, defineEmits, onMounted, nextTick, reactive, watch} from 'vue'

const props = defineProps({
  sides: {
    type: Object,
    required: true
  },
  initSelectedSides: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['selected-sides'])

const selectedSides = reactive({})

const toggleSelectSides = (side, isSelected) => {
  if (isSelected) {
    Object.assign(selectedSides, side);
  }

  if (!isSelected) {
    delete selectedSides[Object.keys(side)[0]];
  }
}

watch(selectedSides, (newValue) => {
  emit('selected-sides', newValue)
})

onMounted( async () => {
  await nextTick()
  Object.assign(selectedSides, props.initSelectedSides)
})
</script>

<style scoped>
</style>